import convert from 'convert-units'

export const unitConverterMixin = {
    data() {
        return {
            /** 
             * Mapper metric to imperial
             */
            metricToImperialMap: {
                m: "ft", // meters -> feet
                km: "mi", // kilometers -> miles
                kg: "lb", // kilograms -> pounds
            }
        }
    },

    methods: {
        /**
         * "from" string must always be a metric system key
         */
        convertFromMetricToImperial(from, value) {
            const metricUnit = from;
            const imperialUnit = this.metricToImperialMap[metricUnit];
            if (!metricUnit || !imperialUnit) {
                console.error(`Unsupported unit: ${from}`);
                return value;
            }
            return convert(value).from(metricUnit).to(imperialUnit);
        },

        /**
         * "from" string must always be a metric system key
         */
        convertFromImperialToMetric(from, value) {
            const metricUnit = from;
            const imperialUnit = this.metricToImperialMap[metricUnit];
            if (!metricUnit || !imperialUnit) {
                console.error(`Unsupported unit: ${from}`);
                return value;
            }
            return convert(value).from(imperialUnit).to(metricUnit);
        },

        /**
         * Get the unit depending on the measure system
         */
        getSystemUnit(from) {
            const measureSystem = localStorage.getItem("measureSystem");
            if (measureSystem === 'imperial') {
                return this.metricToImperialMap[from];
            } else {
                return from;
            }
        },

        getUnitLabel(unit){
            return " (" + this.getSystemUnit(unit) + ")"
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/management/unitConverterMixin.js